import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { axiosInterceptor } from "..";
import { IResponse } from "../interface";

interface UpdatePasswordData {
  currentPassword: string;
  newPassword: string;
}

type IUseUpdatePassword = UseMutationOptions<
  IResponse<null>,
  AxiosError<IResponse<string>>,
  UpdatePasswordData
>;

const useUpdatePassword = (options?: IUseUpdatePassword) => {
  const mutation = useMutation({
    ...options,
    mutationKey: ["update-password"],
    mutationFn: async (data: UpdatePasswordData) => {
      return (
        await axiosInterceptor.put("/b2b-admins/me/update-password", data, {
          headers: {
            source: "web",
          },
        })
      ).data;
    },
    onSuccess: (
      data: IResponse<null>,
      variables: UpdatePasswordData,
      context
    ) => {
      options?.onSuccess?.(data, variables, context);
    },
    onError: (
      error: AxiosError<IResponse<string>>,
      variables: UpdatePasswordData,
      context
    ) => {
      options?.onError?.(error, variables, context);
    },
  });

  return mutation;
};

export default useUpdatePassword;
